import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-status-toggle',
  templateUrl: './status-toggle.component.html',
  styleUrls: ['./status-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusToggleComponent implements OnInit, OnDestroy {
  @Input() public inputStatus?: boolean;
  @Input() public editable = true;
  @Input() public inTable = false;
  @Input() public changeValueFromOutside$?: BehaviorSubject<boolean>;

  @Output() public rowOnChangeState = new EventEmitter<boolean>();
  @Output() public toggleOnClick = new EventEmitter<boolean>();

  public status = new UntypedFormControl();
  public toggleCurrentState?: boolean;
  public changed: boolean;

  private _changeFromOutsideSubscription$?: Subscription;

  ngOnInit(): void {
    if (this.inputStatus) {
      this.status.setValue(true);
    } else this.status.setValue(false);
    this.toggleCurrentState = this.status.value;
    this.changed = false;

    this._changeFromOutsideSubscription$ = this.changeValueFromOutside$?.subscribe((value) => {
      this.status.setValue(value);
    });
  }

  ngOnDestroy(): void {
    this._changeFromOutsideSubscription$?.unsubscribe();
  }

  public onChange() {
    this.toggleCurrentState = !this.toggleCurrentState;
    this.changed = !this.changed;
    this.toggleOnClick.emit(this.status.value);
  }
}
